export const LoadingIcon = (): JSX.Element => (
  <svg
    version="1.1"
    id="Loader"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="3 3 24 24">
    <circle
      className="path_circle"
      fill="none"
      stroke="#fff"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      cx="15"
      cy="15"
      r="9"
    />
  </svg>
);
